import { Component } from 'react';
import {connect} from 'react-redux';
import {actions, Errors, Form} from 'forms/rrf';
import {Col, Row} from 'react-bootstrap';
import LayoutContainer from '../../../layout/layout-container/index';
import ErrorMessages from '../../login/error-messages';
import ArrowButton from '../../../common/button-arrow';
import {convertPoints, savePpcLoad} from '../../../../actions/ppc';
import RequiredInput from '../../../common/form/elements/required-input';
import RequiredSelect from '../../../common/form/elements/required-select';
import t from '../../../../data/translations';

class PpcLoadForm extends Component {
  convertPointsToEuros = (points) => {
    const {dispatch} = this.props;
    dispatch(convertPoints(points, this.props.links['convert-to-value'], 'deep.admin_ppc.management.load.value'));
  };

  onSubmit = (payLoad) => {
    this.props.dispatch(actions.submitFields('deep.admin_ppc.management.load', savePpcLoad(this.props.userId, this.props.loadId, payLoad)));
  };

  render() {
    return (
      <LayoutContainer>
        <Form
          model="deep.admin_ppc.management.load"
          onSubmit={this.onSubmit}
        >
          <Errors className="errors" component={ErrorMessages} model="deep.admin_ppc.management.load"/>
          <Row>
            <Col lg={12}>
              <RequiredInput
                controlId="loadPoints"
                label="Load value (points)"
                model=".points"
                onChange={this.convertPointsToEuros}
                placeholder="e.g. 200"
              />

              <RequiredInput
                controlId="loadValue"
                label={`Load value (${t('currency')})`}
                model=".value"
                placeholder="e.g. 20"
                readOnly
              />

              <RequiredSelect
                controlId="orderStatus"
                hasEmptyValue={false}
                label="Order status"
                model=".status"
                values={this.props.statuses}
              />
            </Col>

          </Row>
          <Row>
            <ArrowButton
              className="float-end"
              disabled={!this.props.formValid}
            >
              Save
            </ArrowButton>
          </Row>
        </Form>
      </LayoutContainer>
    );
  }
}

const mapStateToProps = state => ({
  formValid: state.deep.forms.admin_ppc.management.load.$form.valid,
  links: state.ppc.loadLinks
});

export default connect(mapStateToProps)(PpcLoadForm);
